export function extractBranchAndSection(stuFeeData) {
  let sectionName = "-";
  let branchName = "-";
  if (
    stuFeeData &&
    stuFeeData.student &&
    stuFeeData.student.section &&
    stuFeeData.branchData &&
    stuFeeData.branchData.batchesAndSections
  ) {
    const sectionId = stuFeeData.student.section;
    const batchesAndSections = stuFeeData.branchData.batchesAndSections;
    // Flatten all sections into a single array
    const allSections = Object.values(batchesAndSections).flatMap(
      (batchGroups) =>
        Object.values(batchGroups).flatMap((sectionsArr) => sectionsArr)
    );
    // Find the section object by sectionId
    const foundSection = allSections.find(
      (section) => String(section.sectionId) === String(sectionId)
    );
    sectionName = foundSection ? foundSection.sectionName : "-";
    branchName = stuFeeData.branchData.branchName || "-";
  } else {
    branchName =
      stuFeeData && stuFeeData.branchData && stuFeeData.branchData.branchName
        ? stuFeeData.branchData.branchName
        : "-";
  }
  return { branchName, sectionName };
}
